export default __webpack_public_path__ + "static/media/logo.f238635e.png";